import { render, staticRenderFns } from "./MInplayList.vue?vue&type=template&id=54612e5e&scoped=true"
import script from "./MInplayList.vue?vue&type=script&lang=js"
export * from "./MInplayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54612e5e",
  null
  
)

export default component.exports